var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSso({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.999530792236328 20.000019073486328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.0997829166456419e-12, 6.952658176422119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.29 8.29 L 5.93 10.65 C 4.96 11.62 3.38 11.62 2.40 10.65 C 1.42 9.67 1.42 8.09 2.40 7.11 L 7.11 2.40 C 8.09 1.42 9.67 1.42 10.65 2.40 C 10.97 2.72 11.50 2.72 11.83 2.40 C 12.15 2.07 12.15 1.55 11.83 1.22 C 10.20 -0.41 7.56 -0.41 5.93 1.22 L 1.22 5.93 C -0.41 7.56 -0.41 10.20 1.22 11.83 C 2.85 13.45 5.49 13.45 7.11 11.83 L 9.47 9.47 C 9.80 9.14 9.80 8.62 9.47 8.29 C 9.14 7.97 8.62 7.97 8.29 8.29",
    fill: "#4b1498",
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.458217620849609, 5.713208768923228e-13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11.32 1.22 C 9.69 -0.41 7.06 -0.41 5.43 1.22 L 2.60 4.05 C 2.28 4.37 2.28 4.90 2.60 5.23 C 2.93 5.55 3.45 5.55 3.78 5.23 L 6.61 2.40 C 7.58 1.42 9.17 1.42 10.14 2.40 C 11.12 3.38 11.12 4.96 10.14 5.93 L 4.96 11.12 C 3.98 12.10 2.40 12.10 1.42 11.12 C 1.10 10.79 0.57 10.79 0.24 11.12 C -0.08 11.44 -0.08 11.97 0.24 12.30 C 1.87 13.92 4.51 13.92 6.14 12.30 L 11.32 7.11 C 12.95 5.49 12.95 2.85 11.32 1.22",
    fill: "#4b1498",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSso);
export default __webpack_public_path__ + "static/media/sso.1f96a6bd70d4fc10c6a74f964ed86b99.svg";
export { ForwardRef as ReactComponent };